export default {
    contractListItem: {
        noCounterparty: '(ni nasprotne stranke)',
        viewPosition: 'Prikaži pozicijo',
    },
}
